import * as R from 'ramda'
import { compose, withPropsOnChange } from 'recompose'

import { EmptyData } from '@infotech/base-components'
import { withEquipment } from '../EquipmentFormatter'

const enchance = compose(
  withPropsOnChange([`allData`], ({ allData }) => ({
    entityId: R.prop(`objectId`, allData),
  })),
  withEquipment,
)

const EquipmentViewFormatter = ({ equipment: { info } = {}, data = info }) => data || EmptyData()

export default enchance(EquipmentViewFormatter)
